<app-toast />
<p-confirmDialog />

<section class="motivo-afastamento">
    <div class="motivo-afastamento-inner">
        <app-card-content [border]="false" [title]="'Motivos de Afastamento'" [subtitle]="'Cadastro dos motivos de afastamento de usuários'" [icon]="'pi pi-user-minus'">
            <p-button label="Novo Motivo" icon="pi pi-plus" severity="primary" (click)="abrirNovo()" [appCan]="roleMotivoEditar" card-header />

            <!-- Filtros -->
            <app-filtros-bar (limpar)="limparFiltros()" (filtrar)="aplicarFiltros()">
                <app-filtro-campo label="Descrição" [wide]="true" inputId="motivo-filtro-descricao">
                    <input id="motivo-filtro-descricao" pInputText type="text" class="w-full" [ngModel]="filtroDescricao()" (ngModelChange)="filtroDescricao.set($event)" (keyup.enter)="aplicarFiltros()" placeholder="Pesquisar por descrição..." />
                </app-filtro-campo>
            </app-filtros-bar>

            <!-- Barra de status -->
            <div class="flex justify-between items-center gap-3 mb-4">
                <span class="text-sm text-surface-400 dark:text-surface-500">
                    <span class="font-bold text-surface-700 dark:text-surface-200">{{ motivosView().length }}</span>
                    {{ motivosView().length === 1 ? 'motivo' : 'motivos' }}
                </span>
                <app-table-view-switcher [(viewMode)]="currentView" />
            </div>

            @if (currentView() === 'card') {
                <app-card-sort-pills class="mb-4" [opcoes]="sortOpcoes" [(field)]="sortField" [(order)]="sortOrder" (fieldChange)="onSortCardChange()" (orderChange)="onSortCardChange()" />
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    @for (motivo of motivosPagina(); track motivo.codigo) {
                        <app-card-container>
                            <div class="flex items-center gap-3 min-w-0">
                                <span class="w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center shrink-0">
                                    <i class="pi pi-user-minus" aria-hidden="true"></i>
                                </span>
                                <div class="min-w-0">
                                    <div class="font-semibold leading-tight truncate" [title]="motivo.descricao">{{ motivo.descricao }}</div>
                                    <div class="text-xs text-muted-color mt-0.5">Código {{ motivo.codigo }}</div>
                                </div>
                            </div>
                            <div class="flex justify-end gap-1 mt-4 pt-3 border-t border-surface-200 dark:border-surface-700">
                                <p-button icon="pi pi-pencil" ariaLabel="Editar" [text]="true" [rounded]="true" size="small" (click)="abrirEditar(motivo)" pTooltip="Editar" tooltipPosition="top" [appCan]="roleMotivoEditar" />
                                <p-button
                                    icon="pi pi-trash"
                                    ariaLabel="Remover"
                                    severity="danger"
                                    [text]="true"
                                    [rounded]="true"
                                    size="small"
                                    (click)="confirmarExclusao(motivo)"
                                    pTooltip="Remover"
                                    tooltipPosition="top"
                                    [appCan]="roleMotivoExcluir"
                                />
                            </div>
                        </app-card-container>
                    } @empty {
                        <div class="col-span-full flex flex-col items-center justify-center py-12 text-surface-400">
                            <i class="pi pi-inbox text-5xl mb-3"></i>
                            <span>Nenhum motivo cadastrado.</span>
                        </div>
                    }
                </div>
            } @else {
                <p-table [value]="motivosPagina()" [loading]="carregando()" dataKey="codigo" styleClass="p-datatable-sm motivo-table" [customSort]="true" [sortField]="sortField()" [sortOrder]="sortOrder()" (onSort)="onSortChange($event)" stripedRows>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="codigo" class="w-32">
                                <strong>Código</strong>
                                <p-sortIcon field="codigo" />
                            </th>
                            <th pSortableColumn="descricao">
                                <strong>Descrição</strong>
                                <p-sortIcon field="descricao" />
                            </th>
                            <th class="w-28 text-center"><strong>Ações</strong></th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-motivo>
                        <tr>
                            <td>{{ motivo.codigo }}</td>
                            <td>{{ motivo.descricao }}</td>
                            <td class="text-center">
                                <div class="flex justify-center gap-1">
                                    <p-button icon="pi pi-pencil" ariaLabel="Editar" [text]="true" [rounded]="true" size="small" (click)="abrirEditar(motivo)" pTooltip="Editar" tooltipPosition="top" [appCan]="roleMotivoEditar" />
                                    <p-button
                                        icon="pi pi-trash"
                                        ariaLabel="Remover"
                                        severity="danger"
                                        [text]="true"
                                        [rounded]="true"
                                        size="small"
                                        (click)="confirmarExclusao(motivo)"
                                        pTooltip="Remover"
                                        tooltipPosition="top"
                                        [appCan]="roleMotivoExcluir"
                                    />
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3">
                                <div class="flex flex-col items-center gap-2 py-10 text-surface-400">
                                    <i class="pi pi-inbox text-3xl"></i>
                                    <span class="text-sm">Nenhum motivo cadastrado.</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            }

            <p-paginator (onPageChange)="onPageChange($event)" [first]="first()" [rows]="rows()" [totalRecords]="totalRecords()" [rowsPerPageOptions]="[10, 15, 20]" [appendTo]="'body'" />
        </app-card-content>
    </div>
</section>

<app-motivo-afastamento-detalhe [(visivel)]="modalAberto" [motivo]="motivoEditando()" (salvo)="onSalvo()" />
